import basicController from "servicestack/basic.controller.properties";
import labels from "emun.auth/users/_labels";
import required from "emun.auth/users/_required";

export default class UserManagerDependentController {
  constructor() {
    basicController(this);
    const $ctrl = this;
    $ctrl.labels = labels;
    $ctrl.required = required;
  }
  $onInit() {
    const $ctrl = this;
    $ctrl.query = $ctrl.manager.query;
    this.$state.current.title = "Users List";
  }
}
